<script>
/* jshint esversion: 6 */
import { computed, watch, inject } from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import { isFunction, isNil} from 'lodash';

export default{
    name: 'SelectField',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'disabled': {type: Boolean},
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
	},
    setup(props) {
        const validateChild = inject('validateChild');
        const buttonFunctionParent = inject('buttonFunctionParent');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
            };
            if (validateChild) {
                validateChild(toParent);
            }
        });

        function buttonClick(getfunction) {
            var toParent = {
                'id': props.schemaId,
                'functionVal': getfunction.functionVal,
                'argumentsVal': getfunction.argumentsVal
            };
            if (buttonFunctionParent) {
                buttonFunctionParent(toParent);
            }
        }

        function visibility(field) {
            if (isFunction(field.visible)) { 
                return field.visible.call(props.model);
            }
            if (isNil(field.visible)) return true;
            return field.visible;

        }

        function showButtons() {
            if (props.schema.buttons) {
                if (visibility(props.schema.buttons)) {
                    return 'col-sm-9';
                }
                return 'col-sm-12';
            }
            return 'col-sm-12';
        }

        return {
            buttonClick,
            visibility,
            showButtons,
        };
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldSelect(
       :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        .form-group.row.gy-2.gx-3-align-items-left
            label(
                :for="id" 
                v-if="schema.label && schema.label.length > 0"
            ) 
                |{{ schema.label }}
                span.redAst(v-if="schema.required === true") *
        .form-group.row.gy-2.gx-3-align-items-left(:style="disabled === true ? 'opacity: 0.5; cursor:not-allowed': ''")
            .field-wrap(:class="showButtons()")
                .selectDiv
                    select.form-select(
                        v-model="model[schema.model]" 
                        :id="`${id}`" 
                        :class="[schema.errorShow === true ? 'inputred' : '', , model[schema.model] !== 0 ? 'getWhite' : 'getBlue']"
                        :style="disabled === true ? 'pointer-events:none' : ''"
                    )
                        template(v-for="item in schema.values")
                            option(v-if="parseInt(item.id) === 0" disabled value="0") {{ item.name }}
                            option(v-if="parseInt(item.id) !== 0" :value="item.id") {{ item.name }}
            .col-sm-3(v-if="(schema.buttons && schema.buttons.type === 'text') && visibility(schema.buttons) === true")
                button(v-if="schema.buttons.onclick" @click="buttonClick(schema.buttons.onclick)" :class="schema.buttons.class")
                    | {{ schema.buttons.text }}
                button(v-if="!schema.buttons.onclick"  :class="schema.buttons.class")
                    | {{ schema.buttons.text }}
        .form-group.row.gy-2.gx-3-align-items-left
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }} 
</template>